import { useEffect, useState } from 'react'
import UserService from '../services/UserService';

import {
    Box, Button, FormControl, Input, useToast,
    IconButton, VStack, Heading, Flex, SimpleGrid
} from "@chakra-ui/react";
import { AddIcon, DeleteIcon } from "@chakra-ui/icons";
import { useNavigate } from 'react-router-dom';

const EmergencyContact = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const [rows, setRows] = useState([{ EmConName: "", EmConNo: "", Relation: "", uId: user.uId, UDetNo : 0 }]);
    const navigate = useNavigate()
    const toast = useToast();

    useEffect(() => {
        getEmergency();
    }, []);

    const getEmergency = async () => {
        setRows([]);
        try {
            const data = await UserService.getEmergencyDetail(user.uId);
            setRows(data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    }

    const handleAddRow = () => {
        setRows([...rows, { EmConName: "", EmConNo: "", Relation: "", uId: user.uId, UDetNo :0 }]); // Add a new row
    };

    const handleChange = (index, event) => {
        const newRows = [...rows];
        newRows[index][event.target.name] = event.target.value;
        setRows(newRows);
    };

    const removeRow = (index, event, row) => {
        const rrows = [...rows];
        rrows.splice(index, 1);
        setRows(rrows);
        deleteEmContact(row)
    };

    const deleteEmContact = async(row) =>{
        try {
            await UserService.deleteEmergencyDetail(row.UDetNo);
            
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    }

    const EMForm = async (e) => {
        e.preventDefault();
        // JSON.stringify(rows)
        const res = await UserService.emergencyDetailUpdate(rows);
        if (res.statusCode === 200) {

            toast({
                title: 'Emergency Contact',
                description: res.message,
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
            navigate(0);
        }
    }

    return (
        <Box maxW="1000px" mx="auto" px={4}>
            <Box maxW="900px" mx="auto" mt={2}>
                {/* Header with gradient and rounded top */}
                <Box
                    bgGradient="linear(to-r, #3182ce, #63b3ed)"
                    color="white"
                    py={3}
                    px={6}
                    borderTopRadius="xl"
                    boxShadow="md"
                >
                    <Heading size="sm">Emergency Contacts</Heading>
                </Box>

                {/* Form Card */}
                <Box
                    as="form"
                    method="post"
                    onSubmit={EMForm}
                    bg="white"
                    p={{ base: 4, md: 6 }}
                    borderWidth={1}
                    borderColor="gray.200"
                    borderBottomRadius="xl"
                    boxShadow="xl"
                >
                    <VStack spacing={4} align="stretch">
                        {/* Add Button */}
                        <Flex justify="flex-end">
                            <IconButton
                                aria-label="Add Row"
                                icon={<AddIcon />}
                                size="sm"
                                bg="#62a13b"
                                color="white"
                                onClick={handleAddRow}
                                isRound
                                boxShadow="md"
                                _hover={{ bg: "#538d32" }}
                            />
                        </Flex>

                        {/* Card List */}
                        {rows.map((row, index) => (
                            <Box
                                key={index}
                                p={4}
                                border="1px solid"
                                borderColor="gray.100"
                                borderRadius="lg"
                                boxShadow="md"
                            >
                                <VStack spacing={3} align="stretch">
                                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
                                        <FormControl>
                                            <Input
                                                placeholder="Name"
                                                name="EmConName"
                                                value={row.EmConName}
                                                onChange={(e) => handleChange(index, e)}
                                                size="sm"
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <Input
                                                type="number"
                                                placeholder="Contact No"
                                                name="EmConNo"
                                                value={row.EmConNo}
                                                onChange={(e) => handleChange(index, e)}
                                                size="sm"
                                            />
                                        </FormControl>
                                    </SimpleGrid>

                                    <Flex justify="space-between" align="center">
                                        <FormControl flex="1">
                                            <Input
                                                placeholder="Relation"
                                                name="Relation"
                                                value={row.Relation}
                                                onChange={(e) => handleChange(index, e)}
                                                size="sm"
                                            />
                                        </FormControl>

                                        <IconButton
                                            aria-label="Remove Row"
                                            icon={<DeleteIcon />}
                                            size="sm"
                                            colorScheme="red"
                                            onClick={(e) => removeRow(index, e, row)}
                                            isRound
                                            boxShadow="md"
                                            ml={3}
                                        />
                                    </Flex>
                                </VStack>
                            </Box>
                        ))}

                        {/* Submit Button */}
                        <Box textAlign="center" pt={2}>
                            <Button
                                type="submit"
                                size="md"
                                bg="#62a13b"
                                color="white"
                                _hover={{ bg: "#538d32" }}
                                boxShadow="lg"
                                px={10}
                                py={2}
                                borderRadius="full"
                                fontWeight="bold"
                            >
                                Submit
                            </Button>
                        </Box>
                    </VStack>
                </Box>
            </Box>
        </Box>
    )
}

export default EmergencyContact
